cafm.layout = {

    leftColumnWidth: '20%',
    rightColumnWidth: '25%',
    init: function () {

        if (!cafm.res) return;
        
        if (!isMobile) {

            cafm.layout.setLayoutHeight();

            var layoutCols = $('#layoutColumns');

            if (layoutCols.length) {

                var leftCol = $('#leftCol'),
                    rightCol = $('#rightCol'),
                    colsSplitter,
                    setLeftColWidth = function () {
                        var vw = cafm.util.viewPortWidth();
                        if (vw > 1280 && vw < 1500) {
                            cafm.layout.leftColumnWidth = '17.5%';
                        }
                        else if(vw >= 1500) {
                            cafm.layout.leftColumnWidth = '15%';
                        }
                        else {
                            cafm.layout.leftColumnWidth = '20%';
                        }
                    }
                setLeftColWidth();

                var expandSplitter = function (e) {

                    var pane = $(e.pane);
                    if (pane.attr('id') == 'rightCol') {

                        cafm.cache.set(cafm.res.consts.CacheKey_RightColumnExpanded, true);
                    }
                    else if (pane.attr('id') == 'leftCol') {

                        cafm.cache.set(cafm.res.consts.CacheKey_LeftColumnExpanded, true);
                    }

                    setTimeout(function () {

                        cafm.panel.setMainHeight($('#centreCol,.sideCol'), $('#sub-header').outerHeight());
                    }, 1000);
                }, collapseSplitter = function (e) {

                    var pane = $(e.pane);
                    if (pane.attr('id') == 'rightCol') {

                        cafm.cache.set(cafm.res.consts.CacheKey_RightColumnExpanded, false);
                    }
                    else if (pane.attr('id') == 'leftCol') {

                        cafm.cache.set(cafm.res.consts.CacheKey_LeftColumnExpanded, false);
                    }

                    setTimeout(function () {

                        cafm.panel.setMainHeight($('#centreCol,.sideCol'), $('#sub-header').outerHeight());
                    }, 1000);
                }

                $(window).off('resize.cafmleftcol').on('resize.cafmleftcol', function () {

                    var splitter = $('#layoutColumns').getKendoSplitter();
                    if (splitter) {
                        setLeftColWidth();
                        splitter.size('#leftCol', cafm.layout.leftColumnWidth);
                    }
                })

                var leftColExpanded = cafm.cache.get(cafm.res.consts.CacheKey_LeftColumnExpanded, true),
                    rightColExpanded = cafm.cache.get(cafm.res.consts.CacheKey_RightColumnExpanded, true),
                    cols = [];

                // TODO: determine if this should be cached or not
                leftColExpanded = rightColExpanded = false;

                if (leftCol.data('visibility') == cafm.enums.LayoutElementVisibility.HiddenNotExpandable)
                {
                    leftCol.remove();
                }
                else if (leftCol.length) {

                    var lCollapsed = !cafm.enums.isSingleEnumValue(leftCol.data('visibility'), [cafm.enums.LayoutElementVisibility.Visible, cafm.enums.LayoutElementVisibility.VisibleNotCollapsible]);
                    cols.push({ collapsible: true, collapsed: lCollapsed || !leftColExpanded, size: cafm.layout.leftColumnWidth, resizable: false });
                }

                cols.push({ collapsible: false, resizable: false, scrollable: true });

                if (rightCol.data('visibility') == cafm.enums.LayoutElementVisibility.HiddenNotExpandable)
                {
                    rightCol.remove();
                }
                else if (rightCol.length) {

                    var rCollapsed = !cafm.enums.isSingleEnumValue(rightCol.data('visibility'), [cafm.enums.LayoutElementVisibility.Visible, cafm.enums.LayoutElementVisibility.VisibleNotCollapsible]);
                    cols.push({ collapsible: true, collapsed: rCollapsed || !rightColExpanded, size: cafm.layout.rightColumnWidth, resizable: false });
                }

                colsSplitter = layoutCols.kendoSplitter({
                    panes: cols
                }).data('kendoSplitter');

                colsSplitter.bind('expand', expandSplitter);
                colsSplitter.bind('collapse', collapseSplitter);
                
                if (isTouch) {

                    cafm.util.swipe.swipeVerticalScroll({
                        target: $('#leftCol')
                    });

                    cafm.util.swipe.swipeVerticalScroll({
                        target: $('#rightCol')
                    });

                    cafm.util.swipe.swipeVerticalScroll({
                        target: $('#historyList')
                    });

                    cafm.util.swipe.setupSwipeNav({
                        target: 'leftCol',
                        backward: function () {

                            var pane = layoutCols.children().first();
                            colsSplitter.collapse(pane);
                            collapseSplitter({
                                pane: pane
                            });
                        },
                        preventDefault: true
                    });

                    cafm.util.swipe.setupSwipeNav({
                        target: 'rightCol',
                        forward: function () {

                            var pane = layoutCols.children().last();
                            colsSplitter.collapse(pane);
                            collapseSplitter({
                                pane: pane
                            });
                        },
                        preventDefault: true
                    });
                }
            }
            else this.setSingleCol();
        }

    },
    showLeftColumn: function () {

        var s = $('#layoutColumns').getKendoSplitter();
        if (s) s.expand('#leftCol');
    },
    toggleLeftColumn: function () {

        var s = $('#layoutColumns').getKendoSplitter();
        if (s) s.toggle('#leftCol');
    },
    hideLeftColumn: function () {

        $('.k-splitbar-horizontal').first().hide();
    },
    showRightColumn: function() {

        var s = $('#layoutColumns').getKendoSplitter();
        if (s) s.expand('#rightCol');
    },
    hideRightColumn: function () {

        var s = $('#layoutColumns').getKendoSplitter();
        if (s) s.collapse('#rightCol');
    },
    isRightColumnVisible: function () {

        var rc = $('#rightCol');
        return $('#rightCol').width() > 0;
    },
    toggleRightColumn: function () {

        var s = $('#layoutColumns').getKendoSplitter();
        if (s) s.toggle('#rightCol');
    },
    display: function (args) {

        var sh = $('#sub-header');
        if (sh.length && args.ShowSubHeader != cafm.enums.LayoutElementVisibility.Unspecified) {
            $('#sub-header').toggle(args.ShowSubHeader == cafm.enums.LayoutElementVisibility.Visible);
        }

        if (args.ShowLeftColumn != cafm.enums.LayoutElementVisibility.Unspecified) {
            this.setPaneVisibility('#leftCol', $('.k-splitbar-horizontal:first'), args.ShowLeftColumn);
        }

        if (args.ShowRightColumn != cafm.enums.LayoutElementVisibility.Unspecified) {
            this.setPaneVisibility('#rightCol', $('.k-splitbar-horizontal:last'), args.ShowRightColumn);
        }

        if (!isMobile) cafm.layout.setLayoutHeight();
    },
    setPaneVisibility: function (selector, splitterElement, paneVisibility) {

        var p = $(selector),
            lc = $('#layoutColumns'),
            s = lc.getKendoSplitter();

        if (!p.length || !s) return;
        
        switch (paneVisibility) {

            case cafm.enums.LayoutElementVisibility.Visible:

                splitterElement.show();
                s.expand(selector);
                break;

            case cafm.enums.LayoutElementVisibility.VisibleNotCollapsible:
                
                splitterElement.hide();
                s.expand(selector);
                break;

            case cafm.enums.LayoutElementVisibility.Hidden:

                splitterElement.show();
                s.collapse(selector);
                break;

            case cafm.enums.LayoutElementVisibility.HiddenNotExpandable:

                splitterElement.hide();
                s.collapse(selector);
                break;
        }
    },
    setSingleCol: function () {
        
        if (!($('#leftCol').is(':visible') || $('#rightCol').is(':visible'))) {

            body.addClass('singleCol');
        }
        else {

            body.removeClass('singleCol');
        }
    },
    setLayoutHeight: function () {

        var setHeight = function () {

            cafm.panel.setMainHeight($('#main'));
            cafm.panel.setMainHeight($('#layoutColumns,#centreCol,#mainContentPane,.sideCol'), $('#sub-header').outerHeight());
        }

        setHeight();

        $(window).off('resize.cafmlayout').on('resize.cafmlayout', function () {
            delete window.mainHeight;
            setHeight();
        });
    }
}